export const HOTKEYS = {
  TOGGLE_APP: "toggle_app",
  TOGGLE_LOCK_APP: "toggle_lock_app",
  ZOOM_IN_APP: "zoom_in_app",
  ZOOM_OUT_APP: "zoom_out_app",
  DISCOVER_NODE: "discover_node",
  TOGGLE_LIVE_MODE: "toggle_live_mode",
  TOGGLE_OVERLAY_FULLSCREEN: "toggle_overlay_fullscreen",
  SHOW_LABELS: "show_labels",
} as const;
